import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  IconButton,
  Pagination,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { PDFToolbarProps } from './types';

export const PDFToolbar: React.FC<PDFToolbarProps> = ({
  scale,
  pageCount,
  currentPage,
  saving,
  onZoomIn,
  onZoomOut,
  onPageChange,
  onSave,
}) => {
  return (
    <Paper sx={{ p: 1, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
      <IconButton onClick={onZoomOut} disabled={scale <= 0.5}>
        <ZoomOutIcon />
      </IconButton>
      <Typography variant="body2">{Math.round(scale * 100)}%</Typography>
      <IconButton onClick={onZoomIn} disabled={scale >= 3}>
        <ZoomInIcon />
      </IconButton>

      <Pagination
        count={pageCount}
        page={currentPage}
        onChange={(_, page) => onPageChange(page)}
        size="small"
        sx={{ mx: 2 }}
      />

      <Box sx={{ flex: 1 }} />

      <Button
        variant="contained"
        startIcon={<SaveIcon />}
        onClick={onSave}
        disabled={saving}
      >
        {saving ? 'Saving...' : 'Save Template'}
      </Button>
    </Paper>
  );
};
